<style>
	.edi-accounts {
		overflow: hidden;
	}
	.edi-accounts-head {
		width: 100%;
	}
	.edi-accounts .foot ul {
		position: absolute;
		width: 100%;
		bottom: 0;
		margin: 0;
		padding: 0;
		background-color: #f8f8f8;
		border-top: 1px #d1d1d1 solid;
	}
	.edi-accounts .acc-secure {
		margin-top: .5em;
	}
	.edi-accounts .ui-listview,
	.edi-accounts .ui-listview li {
		border: none;
	}
	.edi-accounts .ui-listview li > a {
		color: #666;
		text-decoration: none;
		display: block;
		padding: .7em 1em;
	}
	.edi-accounts .ui-listview {
		margin-bottom: 1em;
	}
	.edi-accounts-top {
		margin-top: 1em !important;
	}
	.edi-accounts .ui-listview li span {
		position: absolute;
		right: 2em;
		color: #aaa;
		font-size: .88em;
	}
</style>

<template>
<div class="edi-accounts" :style="{ 'height': deviceHeight }">
	<ul class="ui-listview edi-accounts-top">
		<li><router-link :to="{ path: '/mobile', query: { mobile: accountInfo.telephone } }" class="ui-btn-icon-right ui-icon-carat-r">手机号码 <span>{{hideTelephone}}</span></router-link></li>
	</ul>
	<ul class="ui-listview">
		<li><router-link :to="{ path: '/email', query: { email: judgeEmail } }" class="ui-btn-icon-right ui-icon-carat-r">邮箱地址 <span>{{hideEmail}}</span></router-link></li>
	</ul>
	<ul class="ui-listview">
		<li><router-link :to="{ path: '/password-modifym', query: { telephone: accountInfo.telephone } }" class="ui-btn-icon-right ui-icon-carat-r" exact>修改密码</router-link></li>
	</ul>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
</div>
</template>
<!--{{{ script -->
<script>
import TipsAuto from '../components/TipsAuto'
export default {
	data () {
		return {
			tipsauto: false,
			tipsFont: '',
			sec: 1500,
			deviceHeight: this.$root.deviceHeight,
			transitionName: 'page-next',
			accountInfo: {},
			hideTelephone: '',
			hideEmail: '',
			judgeEmail: ''
		}
	},
	components: {
		'tips-auto': TipsAuto
	},
	created () {
		this.$http.get('/cldEdi/business/getCurrentLoginUser').then((response) => {
			this.accountInfo = response.body.data
			if (this.accountInfo.telephone === '') {
				this.hideTelephone = '未绑定手机号'
			} else {
				this.hideTelephone = this.accountInfo.telephone.substr(0, 3) + '******' + this.accountInfo.telephone.substr(-3, 3)
			}
			if (this.accountInfo.email === null) {
				this.hideEmail = '未绑定邮箱'
				this.judgeEmail = null
			} else {
				this.judgeEmail = this.accountInfo.email
				var arr = this.accountInfo.email.split('@')
				this.hideEmail = arr[0].substr(0, 3) + '***' + arr[0].substr(-3, 3) + '@' + arr[1]
			}
		}, (response) => {
			var self = this
			self.tipsauto = true
			self.tipsFont = '服务中断，稍后请重试！'
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		})
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Accounts.vue?6b64fb16